import { Injectable } from "@angular/core";
import { HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { LanguageService } from "../i18n/language.service";

@Injectable()
export class LanguageInterceptor implements HttpInterceptor {

    constructor(private languageService: LanguageService) { }

    intercept(req: HttpRequest<any>, next: HttpHandler) {

        const lang = this.languageService.getCurrentLang();

        const request = req.clone({
            setHeaders: {
                'Accept-Language': lang
            }
        });

        return next.handle(request);
    }
}